import { ConfigurationError } from '@cian/peperrors/shared';
import * as React from 'react';

import { EStatus } from '../../types/context';
import { useContext } from '../../utils/useContext';
import { EarlyAccessPaywallModalContainer } from '../EarlyAccessPaywallModalContainer';
import { FallbackModalContainer } from '../FallbackModalContainer';

export const RootContainer: React.FC = () => {
  const context = useContext();

  if (!context) {
    throw new ConfigurationError({
      domain: 'EarlyAccessPaywall',
      message: "EarlyAccessPaywall used outside of it's context",
    });
  }

  if (context.status === EStatus.Succeed) {
    return <EarlyAccessPaywallModalContainer />;
  }

  if (!context.open) {
    return null;
  }

  return <FallbackModalContainer />;
};
